import Hidden from 'components/Field/Hidden';
import Input from 'components/Field/Input';
import Textarea from 'components/Field/Textarea';
import Checkbox from 'components/Field/Checkbox';
import Select from 'components/Field/Select';
import Tag from 'components/Field/TagBox';
import RichTextareaComponent from 'components/Field/RichTextarea';

export const InputField = Input;
export const TextareaField = Textarea;
export const CheckboxField = Checkbox;
export const SelectField = Select;
export const HiddenField = Hidden;
export const TagBox = Tag;
export const RichTextarea = RichTextareaComponent;

export const validators = {
  required: value => (value ? undefined : 'Required'),

  minLength: min => value => {
    if (!value || value.length < min) {
      return `Must be ${min} characters or more`;
    }
    return undefined;
  },
};
